import { isValidElement, ReactNode } from 'react';

export function isEmptyNode(node: ReactNode): boolean {
    if (node == null || node === false || node === '') return true;

    if (Array.isArray(node)) return node.every(isEmptyNode);

    if (isValidElement(node)) {
        const children = node.props?.children;
        return children === undefined ? false : isEmptyNode(children);
    }

    return false;
}
